import script from "./PlayerControls.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayerControls.vue?vue&type=script&setup=true&lang=js"

import "./PlayerControls.vue?vue&type=style&index=0&id=28c50055&scoped=true&lang=less"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28c50055"]])

export default __exports__